import React from 'react';
import { Trash2 } from 'lucide-react';
import { useActiveSessions, useTerminateSession } from '@/hooks/useSettings';
import styles from './ActiveSessions.module.css';

/**
 * ActiveSessions Component
 * Displays and manages active user sessions
 */
const ActiveSessions = () => {
  const { data: sessionsData, isLoading } = useActiveSessions();
  const terminateSessionMutation = useTerminateSession();
  
  const sessions = sessionsData?.sessions || [];

  const handleTerminateSession = async (sessionId) => {
    try {
      await terminateSessionMutation.mutateAsync(sessionId);
    } catch (error) {
      // Error handled by mutation hook
    }
  };

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loader}>
          <span className={styles.loaderText}>loading</span>
          <span className={styles.load}></span>
        </div>
      </div>
    );
  }

  if (sessions.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>No active sessions found</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {sessions.map((session) => (
        <div key={session.id} className={styles.sessionItem}>
          <div className={styles.sessionInfo}>
            <div className={styles.sessionDetails}>
              <span className={styles.sessionDevice}>{session.device || 'Unknown Device'}</span>
              <span className={styles.sessionLocation}>{session.location || 'Unknown Location'}</span>
              <span className={styles.sessionTime}>
                Last active: {session.lastActive ? new Date(session.lastActive).toLocaleString() : 'N/A'}
              </span>
            </div>
            {session.isCurrent && (
              <span className={styles.currentBadge}>Current</span>
            )}
          </div>
          {!session.isCurrent && (
            <button
              className={styles.terminateButton}
              onClick={() => handleTerminateSession(session.id)}
              aria-label="Terminate session"
            >
              <Trash2 size={16} />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default ActiveSessions;
